<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          v-model="group"
          :items="groups"
          item-title="name"
          item-value="id"
          label="Группа"
          @update:modelValue="getStudents(group)"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
          v-model="student"
          :items="students"
          item-title="name"
          item-value="id"
          label="Студент"
          @update:modelValue="getStudentPractice(student)"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <practical v-if="student !== ''" 
        :student_id="student"
        :practiceData = "practice"
        ></practical>
      </v-col>
    </v-row>
    <v-overlay v-model="overlay"></v-overlay>
  </v-container>
  
</template>
<script>
import practical from "./practicalTrainingTable.vue";
export default {
  components: {
    practical,
  },
  data() {
    return {
      groups: [],
      group: null,
      students: [],
      student: "",
      practice: [],
      overlay: false
    };
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/gradesBook2/practicalTraining/getGroups"
      )
      .then((response) => {
        this.groups = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    getStudents(group_id) {
      this.overlay = true;
      this.student = "";
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/gradesBook2/practicalTraining/getStudents",
          new URLSearchParams({
            group_id: group_id
          })
        )
        .then((response) => {
          this.students = response.data;
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          this.overlay = false;
        });
    },
    getStudentPractice(student_id){
      this.overlay = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/gradesBook2/practicalTraining/getpracticalTraining",
          new URLSearchParams({
            student_id: student_id
          })
        )
        .then((response) => {
          this.practice = response.data;
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          this.overlay = false;
        });
      
    }
  },
};
</script>
